import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";
const {
  colors: { ui },
} = constants;

import { SEARCH_PAGE_BREAKPOINTS } from "@/search/Langston/SearchPage/SearchPage.constants";

export const filterHeaderContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  flexWrap: "wrap",
};

export const buttonCss = {
  root: {
    padding: "8px",
    marginLeft: "8px",
    textWrap: "nowrap",
  },
};

export const needleCss = {
  fontWeight: "bold",
};

export const filterAndSortVisibilityCss = {
  display: "none",

  [`@media (max-width: ${SEARCH_PAGE_BREAKPOINTS.MD}px)`]: {
    display: "inline-flex",
  },
};

export const totalResultsCss = {
  padding: "16px 0",
  fontWeight: "bold",
  borderBottom: `1px solid ${ui.neutral[100]}`,
  width: "100%",
  margin: "0px 16px",
};
